
// Mixing jQuery and Node.js code in the same file? Yes please!

/*$(function(){

    $('.logField').append('<br>Comando recibido: <span>' + 'Hola comando' + '</span>');    

});*/
import * as firebase from 'firebase'
import assign from 'object-assign';
import { platformHandler } from '../platforms/PlatformHandler'
import { userHandler } from '../platforms/UserHandler'
import { PlatformEnum } from '../App/constants';

export class FlipwitFirebaseConnector {
  constructor() {
    
    let firebaseConf = JSON.parse(process.env.REACT_APP_FIREBASE_CONF)
    firebase.initializeApp( firebaseConf ); //FIREBASE_CONF defined by config settings in webpack

    this.loggedUser = "";
    this.arrayListenerActMsgs = [];
    this.newItems = false;
    this.uniqueConnectionID = "";

    this.staticState = null;
    this.firstStateProcessed = null;
    this.callbackStaticState = null;

    this.callbacksHotPlugins = {};
  }


  init() {
    if(!this.auth)
      this.initFirebase()
  }

// Sets up shortcuts to Firebase features and initiate firebase auth.
  initFirebase() {
    console.log('QUE INICIEEEE')
    // Shortcuts to Firebase SDK features.
    this.auth = firebase.auth();
    //this.auth.signOut();
    this.database = firebase.database();
    this.storage = firebase.storage();
    // Initiates Firebase auth and listen to auth state changes.
    
    this.auth.onAuthStateChanged( this.onAuthStateChanged );
  };

  getUserUid = () => {
    return this.loggedUser;
  }

  getFullUserUid = (uidExhibitor) => {
    if(uidExhibitor!==this.loggedUser) {
      return this.loggedUser;
    } else {
      return this.loggedUser + this.checkSameExhibitor(this.loggedUser);
    }
  }

  // Signs-out of Toglea Client.
  signOut() {
    userHandler.signOut();
    // Sign out of Firebase.
    this.auth.signOut();
  }


  // Loads chat messages history and listens for upcoming ones.
  loadMessages = () => {
      // Reference to the /messages/ database path.
      this.commandsRef = this.database.ref(this.loggedUser + '/commands');

      // Make sure we remove all previous listeners.
      this.commandsRef.off();

      // Loads the last 12 messages and listen for new ones.
      var setMessage = (data) => {
        
        if (!this.newItems) return;

        var val = data.val(); 

        console.log('llega message ' + val.command)

        if( val.command === "InteractionFeature") {//si llega el comando desde la web, no deberia hacerlo porque cuando se cambia de pantalla a presentation mode se inicia el flujo para comenzar presentacion
          if( val.interactionType === "Init") {
              return;
          }   

          if (platformHandler.currentPlatform === PlatformEnum.ELECTRON) {
            platformHandler.actionInPresentation( val.interactionType );
          }
        }else{
          console.log('llego un nuevo tales')
          if( val.owner !== this.uniqueConnectionID ){
            platformHandler.actionDrawing( val );
          }
        }
      };      
      
      this.commandsRef.limitToLast(1).on('child_added', setMessage);

      var setNewMessages = (data) => {
        this.newItems = true;    
      };

      this.commandsRef.once('value', setNewMessages);
  }

  //Aca se setean los listener de los cambios en state
  loadPresentationMsgs = ( callback, idUserPresentation, code ) => {
    
    //Si tengo el id de usuario como nulo entonces tomo mi usuario ya que soy el expositor, pues si me pasan el
    //id del usuario es para cuando yo me estoy uniendo como User a una sesion
    idUserPresentation = (idUserPresentation==null ? this.getUser() : idUserPresentation);

    console.DEBUG_FLIPWIT('idUserPresentation: ' + idUserPresentation + ' codeSession ' + code)
    this.presentationRef = this.database.ref(idUserPresentation + '/state');
    // Make sure we remove all previous listeners.
    this.presentationRef.off();

    var setMessage = (data) => {

      console.DEBUG_FLIPWIT("Llega nuevo estado y mi codigo es " + platformHandler.getSessionCode());

      var val = data.val();

      if(val==null){
        callback( false, val);
        return;
      }   
      
      //console.DEBUG_FLIPWIT("val " + JSON.stringify(val));
      
      //Esto es para los presenter de la web, si no tengo el codigo aun entonces lo tomo, a excepcion de cuando
      //el estado es para indicar que se cerro la sesion, en ese caso puede ser de una sesion anterior
      if(platformHandler.getSessionCode()!==val.code && val.sessionClosed!==true) {
        platformHandler.setSession(val.code);
      }

      console.DEBUG_FLIPWIT("Pasa aca con " + (platformHandler.getSessionCode()!==val.code));

      //Si esto es diferente es porque el estado es de una sesion vieja y se debe ignorar
      if(platformHandler.getSessionCode()!==val.code && val.sessionClosed===false)  return;
      
      if(val.sessionClosed===true && platformHandler.getSessionCode()!=="") {
        //if(this.presenceRef!==null && val!==undefined) this.presenceRef.remove();
        platformHandler.sessionClosed();
        return;
      }



      //Cuando recibe un estado revisa si ya esta escuchando si es o no una session 
      //con un electron conectado
      if(this.electronRef===null || this.electronRef===undefined) {
        console.DEBUG_FLIPWIT('escuchando la session <' + code + '>');
        this.initElectronSessionData(code!==null&&code!==undefined?code:val.code);
      }
      
      callback( true, val);

      //Dice que ya se proceso un estado
      this.firstStateProcessed = true;

      if(this.staticState!==null && this.staticState!==undefined) {
        this.processStaticState(this.staticState);
      }    
    };
    
    this.presentationRef.on('value', setMessage);
  }

  //Aca se setean los listener para obtener la informacion estatica de state
  loadPresentationStaticState( callback, idUserPresentation, code ) {
    
    //Si tengo el id de usuario como nulo entonces tomo mi usuario ya que soy el expositor, pues si me pasan el
    //id del usuario es para cuando yo me estoy uniendo como User a una sesion
    idUserPresentation = (idUserPresentation==null?this.getUser():idUserPresentation);

    this.staticStateRef = this.database.ref(idUserPresentation + '/staticState');
    // Make sure we remove all previous listeners.
    this.staticStateRef.off();

    var setStaticState = (data) => {
      console.DEBUG_FLIPWIT('llega static aca', this.firstStateProcessed)
      this.staticState = data;
      this.callbackStaticState = callback;
      //El estado estatico no se procesa hasta que haya llegado el primer state normal
      //pues el state normal podria ser que esa sesion ya se cerro.
      if(this.firstStateProcessed !== true) return;

      this.processStaticState(data);

    };
    
    this.staticStateRef.on('value', setStaticState);
  }

  processStaticState(data) {
    var val = data.val();    

    if(val==null) return;  
    
    console.DEBUG_FLIPWIT("Llega nuevo estado estatico y mi codigo es <" + platformHandler.getSessionCode() + "> vs <" + val.code + ">");            
    
    //Esto es para los presenter de la web, si no tengo el codigo aun entonces lo tomo, a excepcion de cuando
    //el estado es para indicar que se cerro la sesion, en ese caso puede ser de una sesion anterior
    if(platformHandler.getSessionCode()==="") {
      platformHandler.setSession( val.code );
    }

    //Si esto es diferente es porque el estado es de una sesion vieja y se debe ignorar
    if(platformHandler.getSessionCode()!==val.code)  return;
    
    console.DEBUG_FLIPWIT("val static " + JSON.stringify(val))

    //Indica al callback que la informacion que llega es la estatica para no tener 2 listener diferentes
    val.isStaticInfo = true;

    this.callbackStaticState( true, val);         
    
    this.staticState = null;
  }

  sendMsgActivity( numSlide, msg, idActivity, idUserPresentation, nameUser = "", emailUser = "",allowMultipleMessages,isAddition ){
    
    console.log('Los datos que tiene antes',this.getUser(),idUserPresentation);
    //idUserPresentation = ((idUserPresentation===null||idUserPresentation===""||idUserPresentation===undefined) ? this.getUser() : idUserPresentation);
    idUserPresentation = ((idUserPresentation===null||idUserPresentation==="") ? this.getUser() : idUserPresentation);

    let userNode = this.loggedUser;

    if(platformHandler.demoMode!==null) {
      userNode = userNode.substr(userNode.indexOf("/")+1)
    }

    console.log('Enviar msg send ' + numSlide + ":" + msg + "  " + idActivity + " " + idUserPresentation,allowMultipleMessages)
    
    // Check that the user entered a message and is signed in.
    if (this.checkSignedIn()) {
        
        var nodeName = idUserPresentation + "/currentData/" + idActivity + "/" + userNode + this.checkSameExhibitor(idUserPresentation) + (allowMultipleMessages?'_'+new Date().getTime():'');
        console.log('nodeName',nodeName);

        this.msgRef = this.database.ref(nodeName);
        
        var fnCreateNode = () => {
          this.msgRef.remove();
          this.msgRef.off();

          this.msgRef.set({
            numSlide:numSlide,
            msg: msg,
            nameUserFW: nameUser,
            emailUserFW: emailUser
          }).catch(function(error) {
            console.error('Error writing new message to Firebase Database', error);
          });
        }

        if(!isAddition) {
          fnCreateNode();
        }
        else {
          //Verifica si ya tiene el nodo
          this.msgRef.once('value', (snapshot) => {
            if (snapshot.hasChild('nameUserFW')) {
              this.msgDataRef = this.database.ref(nodeName+"/msg");
              this.msgDataRef.push(msg);
            }
            else {
              this.msgRef.set({
                numSlide:numSlide,
                nameUserFW: nameUser,
                emailUserFW: emailUser
              }).then((error) => {
                if(error) {
                  console.error('Error writing new message to Firebase Database', error);
                }
                else {
                  this.msgDataRef = this.database.ref(nodeName+"/msg");
                  this.msgDataRef.push(msg);
                }
              })
            }
          });
        }        
      }
    }

  /*sendMsgActivity( numSlide, msg, idActivity, idUserPresentation, nameUser = "", emailUser = "",allowMultipleMessages ){
  idUserPresentation = ((idUserPresentation===null||idUserPresentation==="") ? this.getUser() : idUserPresentation);

  let userNode = this.loggedUser;

  if(platformHandler.demoMode!==null) {
    userNode = userNode.substr(userNode.indexOf("/")+1)
  }

  console.log('Enviar msg ' + numSlide + ":" + msg + "  " + idActivity + " " + idUserPresentation,allowMultipleMessages)
  
  // Check that the user entered a message and is signed in.
  if (this.checkSignedIn()) {
      
      console.log('Se va a conectar a ',idUserPresentation + "/currentData/" + idActivity + "/" + userNode + this.checkSameExhibitor(idUserPresentation) + (allowMultipleMessages?'_'+new Date().getTime():''));
      this.msgRef = this.database.ref(idUserPresentation + "/currentData/" + idActivity + "/" + userNode + this.checkSameExhibitor(idUserPresentation) + (allowMultipleMessages?'_'+new Date().getTime():''));
      this.msgRef.remove();
      this.msgRef.off();

      this.msgRef.set({
        numSlide:numSlide,
        msg: msg,
        nameUserFW: nameUser,
        emailUserFW: emailUser
      }).catch(function(error) {
        console.error('Error writing new message to Firebase Database', error);
      });
    }
  }*/

  sendState(stateData) {
    console.DEBUG_FLIPWIT('Enviar state ' + stateData.comment + ":" + stateData.idActivity + " logueado? " , this.checkSignedIn())
    
    // Check that the user entered a message and is signed in.
    if (this.checkSignedIn()) {
       
        this.stateRef = this.database.ref(this.loggedUser + "/state");
        //this.stateRef.remove();
        //this.stateRef.off();

        this.stateRef.set(stateData).catch(function(error) {
          console.error('Error writing new message to Firebase Database', error);
        });
    }
  }

  sendStaticState(stateData) {
    console.DEBUG_FLIPWIT('Enviar staticState ' + JSON.stringify(stateData))
    
    // Check that the user entered a message and is signed in.
    if (this.checkSignedIn()) {
       
        this.sendStaticStateRef = this.database.ref(this.loggedUser + "/staticState");
        //this.sendStaticStateRef.remove();
        //this.sendStaticStateRef.off();

        this.sendStaticStateRef.set(stateData).catch(function(error) {
          console.error('Error writing new staticState to Firebase Database', error);
        });
    }
  }

  sendCommand(command) {
    console.log('Enviar a ',command, " desde ", this.auth )
    console.trace()
    
    // Check that the user entered a message and is signed in.
    if (this.checkSignedIn()) {
        // Add a new message entry to the Firebase Database.
        this.commandsRef.push(command).catch(function(error) {
          console.error('Error writing new message to Firebase Database', error);
        });
    }
  }


  initElectronSessionData(codeSession) {
    console.DEBUG_FLIPWIT('Crea el listener para saber si la session es electron ' + codeSession)
    
    // Check that the user entered a message and is signed in.
    if (this.checkSignedIn()) {
        this.electronRef = this.database.ref(this.loggedUser + "/electronSession");
        this.electronRef.remove();
        this.electronRef.off();
        
        var setElectronSession = (data) => {
          var val = data.val();
          if(val!==null && val!==undefined) platformHandler.setElectronSession();          
        };
        
        this.electronRef.once('value', setElectronSession);
    }
  }

  sendActiveElectron(codeSession) {
    console.DEBUG_FLIPWIT('Enviar Activar Electron para sesion ' + codeSession)
    
    // Check that the user entered a message and is signed in.
    if (this.checkSignedIn()) {
        this.electronRef.set({
            electronSession: true,
            codeSession: codeSession
        }).catch(function(error) {
          console.error('Error writing new message to Firebase Database', error);
        });
    }
  }

  closeSession(codeSession) {
    this.database.ref(this.loggedUser + "/electronSession").remove();
    console.DEBUG_FLIPWIT('ESTA REMOVIENDO')
    //this.database.ref(this.loggedUser + "/presence").remove();
    this.database.ref(this.loggedUser + "/commands").remove();
    this.database.ref(this.loggedUser + "/currentData").remove();
    this.database.ref(this.loggedUser + "/staticState").remove();
    this.database.ref(this.loggedUser + "/infoLocal").remove();
    this.database.ref(this.loggedUser + "/hotPlugin").remove();
    //TODO2 Borrar las preguntas al cerrar sesion
    this.database.ref(this.loggedUser + "/hotPluginInfo").remove();
    this.database.ref(this.loggedUser + "/state").set({sessionClosed:true, code: codeSession});
  }


  // Triggers when the auth state change for instance when the user signs-in or signs-out.
  /*Esto se llama incluso cuando el usuario no esta logueado, indicando que ya esta conectado a firebase
  pero sin usuario*/
  onAuthStateChanged = (user) => {

    var scope = this;
    console.log('user eis ' , user, platformHandler.demoMode)
    if (user) {
      if (this.isAnonymous() || platformHandler.demoMode!==null) {
        //TODO esto puede ir en funcion
        if(platformHandler.demoMode!==null) scope.currentUser = platformHandler.demoMode.demoUserObj;

        scope.loggedUser = scope.getUser();
        platformHandler.authStateChanged(user);
      } else {
        userHandler.loginOnBackend( user.providerData[0], scope.auth.currentUser.uid ).then(function(realUser) {
          
          try{
            console.DEBUG_FLIPWIT('user ' + realUser );
            scope.currentUser = realUser;
            scope.loggedUser = scope.getUser();
            
            platformHandler.authStateChanged(realUser);
          }
          catch(err) {
            console.log('ERROR EN AUTH',err);
          }
        }).catch((err) => {
          console.error('Error on signing in!', err);
          platformHandler.authStateChanged(null);
          // TODO: Show a Dialog here to let the users restart the app... or report the error or something...
        });
      }

    } else { // User is signed out!
      console.DEBUG_FLIPWIT('User is not logged in',user);
      platformHandler.authStateChanged(user);
    }
  }

// Returns true if user is signed-in. Otherwise false and displays a message.
  checkSignedIn() {
    // Return true if the user is signed in Firebase
    console.log("para checkear usa ",this.auth)
    if(this.auth) console.log("y",this.auth.currentUser);
    
    if ( this.auth && this.auth.currentUser) {
      return true;
    }

    return false;
  }

  getUser() {
  
    //Si esta en modo demo
    if(platformHandler.demoMode!==null) {
      return platformHandler.demoMode.demoUser;
    }

    if(this.currentUser) {
      return this.currentUser.username;
    }

    console.log(this.auth)
    console.log(this.auth.currentUser)
    // backward compatibility with the very ugly and bad user UIDs... :(
    
    if(this.auth.currentUser===null) return null;

    return this.auth.currentUser.uid;
  }

  signInWithEmailAndPassword(userdata) {
    return firebase.auth().signInWithEmailAndPassword(userdata.email.trim(), userdata.password.trim());
  }

  fetchSignInMethodsForEmail(email) {
    return firebase.auth().fetchSignInMethodsForEmail(email);
  }

  signInWithCredential(oauth){
    var credential = firebase.auth.GoogleAuthProvider.credential(oauth.id_token, oauth.access_token);
    firebase.auth().signInWithCredential(credential)
    .then(function(authData) {
      // here we can execute some other custom actions after firebase auth....

    }, function(err) {
      console.error(err);
    });
  }

  signInGoogleProvider() {
    var provider = new firebase.auth.GoogleAuthProvider();
    this.auth.signInWithPopup(provider);
  }

  signInAnonymously( nick,fnCallback ) { 
    
    console.log('Pide que loguee anonimo');

    firebase.auth().signInAnonymously().then(() => {
      console.log("Signea con parametro",fnCallback)
      if(fnCallback) fnCallback();
    }).catch(function(error) {
      //var errorCode = error.code;
      //var errorMessage = error.message;
      console.log('error al loguear',error); 
    });
  }

  isAnonymous(){

    if(platformHandler.demoMode!==null) return true;

    return this.auth.currentUser.isAnonymous;
  }

  //listener que se pone sobre el current data de una actividad para obtener lo que la 
  //audiencia responde, si idUser es null se coloca el actual
  setListenerActMsgs( listener, idActivity, idUser ){

    if( this.ActMsgsRef === null || this.ActMsgsRef === undefined) {
      this.ActMsgsRef = [];
    }

    // Reference to the /messages/ database path.
    if( this.ActMsgsRef[idActivity] ){
      // Make sure we remove all previous listeners.
      this.ActMsgsRef[idActivity].off();
    }

    this.arrayListenerActMsgs.push( listener )

    console.DEBUG_FLIPWIT('setListenerActMsgs: '+ (idUser==null?this.getUser():idUser) + '/currentData/' + idActivity)
    this.ActMsgsRef[idActivity] = this.database.ref( (idUser==null?this.getUser():idUser) + '/currentData/' + idActivity);

    var setMessage = (data) => {
      this.arrayListenerActMsgs.forEach( (listenerRef) => ( listenerRef( data ) ) );
    }

    //cada q se actualiza un valor se trae todo, lo hacemos asi o de otra forma?
    this.ActMsgsRef[idActivity].on('value', setMessage);
  }

  removeListenersActMsg(){

  }

  /*
    Obtiene el ultimo mensaje que yo haya enviado en la actividad con idActivity (nodo currentData)
   */
  getMsgActivityUser( listener, idActivity, idUser ){
    // Reference to the /messages/ database path.
    if( this.ActMsgsValueRef ){
      // Make sure we remove all previous listeners.
      this.ActMsgsValueRef.off();
    }
  
    console.log('Pone a escuchar',idUser + '/currentData/' + idActivity + "/" + this.loggedUser + this.checkSameExhibitor(idUser));

    this.ActMsgsValueRef = this.database.ref( idUser + '/currentData/' + idActivity + "/" + this.loggedUser + this.checkSameExhibitor(idUser));

    //cada q se actualiza un valor se trae todo, lo hacemos asi o de otra forma?
    this.ActMsgsValueRef.once('value', listener);
  }

  setAnonymousNick(){
    if ( this.checkSignedIn() && this.isAnonymous() ) {
      var user = this.auth.currentUser;

      user.updateProfile({
        displayName: platformHandler.nick,
      }).then(function() {

      }, function(error) {
         console.DEBUG_FLIPWIT('Error on setAnonymousNick')
      });
    }
  }

  sendPPTsOpen( ppts ) {
    // Check that the user entered a message and is signed in.
    if (this.checkSignedIn()) {
       
        this.infoLocalRef = this.database.ref(this.loggedUser + "/infoLocal/openPPTs");
        this.infoLocalRef.remove();
        this.infoLocalRef.off();

        this.infoLocalRef.onDisconnect().remove();

        console.DEBUG_FLIPWIT('SEND PPTS LOCAL')
        this.infoLocalRef.set(ppts).catch(function(error) {
          console.error('Error writing new message to Firebase Database', error);
        });
    }
  }

  getPPTsOpen( ) {
    // Check that the user entered a message and is signed in.
    if (this.checkSignedIn()) {
       
        console.DEBUG_FLIPWIT('ruta: ' + this.loggedUser + "/infoLocal/openPPTs")
        this.infoLocalRef = this.database.ref(this.loggedUser + "/infoLocal/openPPTs");
        this.infoLocalRef.off();

        var setNewMessages = (data) => {
          platformHandler.pptsOpen( data.val()) ;   
        };

        this.infoLocalRef.on('value', setNewMessages);
    }
  }

  checkSameExhibitor = ( idUserPresentation ) =>{
    //si soy audiencia y me conecto a mi propia presentacion
    if( idUserPresentation === this.getUser() && !platformHandler.isExhibitor ){
      return "-audience";
    }
    return "";
  }
  
  reportAndListenPresence = (idUserPresentation,nick) => {

    return new Promise( (resolve, reject) => {
      console.log("entra a promesa con ",this.presenceRef)
      if(this.presenceRef!==null && this.presenceRef!==undefined) {
        resolve();
        return;
      }

      //Si tengo el id de usuario como nulo entonces tomo mi usuario ya que soy el expositor, pues si me pasan el
      //id del usuario es para cuando yo me estoy uniendo como User a una sesion
      idUserPresentation = (idUserPresentation==null ? this.getUser() : idUserPresentation);

      console.log("Escucha desconexiones para ",idUserPresentation,this.checkSameExhibitor(idUserPresentation))
      var amOnline = this.database.ref(".info/connected");

      console.log("Info demo en fire",platformHandler.demoMode,this.loggedUser)
      if(platformHandler.demoMode!==null && this.loggedUser==="") {
        this.loggedUser = this.getUser();
        console.log('Deja el loggedUser como ',this.loggedUser);
      }

      //En modo demo el nombre del usuario tiene un / por lo que para este caso se reemplaza el / por un _ pues el / haria crear
      //un hijo adicional en el firebase
      let userPresenceKey = this.loggedUser.replace("/","_")

      console.log('La llave de presencia es ',idUserPresentation + "/presence/connections/" + userPresenceKey + this.checkSameExhibitor(idUserPresentation))
      this.presenceRef = this.database.ref(idUserPresentation + "/presence/connections/" + userPresenceKey + this.checkSameExhibitor(idUserPresentation));
      
      //this.presenceRefData = this.database.ref(idUserPresentation + "/presence/presenceData/" + this.loggedUser);
      //this.presenceRefData.update({data:{nick:nick}});
      //this.presenceRef.set({email:platformHandler.getEmail(), name:platformHandler.getName()});
      let tempEmail = platformHandler.getEmail() || 'none';
      let tempName = platformHandler.getName() || 'none';
      let tempUserAgent = navigator.userAgent;

      let objPresence = {present:true, email:tempEmail?tempEmail:'', name:tempName?tempName:'',userAgent:tempUserAgent,mobile:platformHandler.mobilecheck()};
      //let objPresence = {present:true, email:tempEmail?tempEmail:'', name:tempName?tempName:''};

      console.log('Va a reportar con ',objPresence);

      this.uniqueConnectionID = this.presenceRef.push(objPresence).getKey();    
      console.log("el id generado fue " + this.uniqueConnectionID);
      
      let refPing = this.database.ref(this.getUser() + "/pingExhibitor/" + this.uniqueConnectionID );
      refPing.set({lastTime:this.getTimestampConstant()})
      refPing.onDisconnect().remove();

      this.presenceRef = this.database.ref(idUserPresentation + "/presence/connections/" + userPresenceKey + this.checkSameExhibitor(idUserPresentation) + "/" + this.uniqueConnectionID);

      amOnline.on('value', (snapshot) => {

        if (snapshot.val()) {
          //this.presenceRefData.onDisconnect().remove();
          if(this.presenceRef) {
            this.presenceRef.onDisconnect().remove();
            this.objPresence = {connected:true, nick:nick, email:tempEmail, name:tempName,userAgent:tempUserAgent,mobile:platformHandler.mobilecheck()};
            this.presenceRef.set(this.objPresence);
            //this.presenceRef.set({connected:true, nick:nick, email:tempEmail, name:tempName});
          }
        }

        resolve();
      });
    });
  }

  reportAsFirstPresence = () => {
    this.objPresence.firstPresence = true;
    this.presenceRef.set(this.objPresence);
  }

  removeOldPresences = ( data, pingData ) =>{
    var presencesToRemove = [];
    for( var presence in data ){
      if( pingData[presence] ){
        if( (Date.now() - pingData[presence].lastTime ) > 1000 ){
          presencesToRemove.push( presence );
          delete data[presence];
        }
      }
      else{
        presencesToRemove.push( presence );
        delete data[presence];
      }
      
    }
    return presencesToRemove;
  }

  listenAllExhibitorPresence = (callbackPresence) => {

    this.allPresenceRef = this.database.ref(this.getUser() + "/presence/connections/" + this.loggedUser);
    this.allPresenceRef.off();

    this.firstTimePresence = true;

    return new Promise( (resolve, reject) => {
      setTimeout( () => {//se espera 600 milisegundos para que los que detectaron la nueva presencia actualicen el tiempo para saber si esta activo o no
        this.database.ref(this.getUser() + "/pingExhibitor").once('value', (pingSnapshot) => {
          this.allPresenceRef.on('value', (snapshot) => {
            let data = snapshot.val();
            
            if( data ){
              if ( this.firstTimePresence ){//si yo soy el nuevo miro quienes estan desconectados para removerlos
                //TODO let presencesToRemove = this.removeOldPresences( data, pingSnapshot.val() );
                this.firstTimePresence = false;//luego ya no soy yo el nuevo
                /*TODO removed temporaly for (var i = 0; i < presencesToRemove.length; i++) {
                  console.log('REMOVE ' + presencesToRemove[i])
                  this.database.ref(this.getUser() + "/presence/connections/" + this.loggedUser + "/" + presencesToRemove[i]).remove();
                  this.database.ref(this.getUser() + "/pingExhibitor/"+ presencesToRemove[i]).remove();
                }*/
              }
              else{
                //si llego alguien actualizo mi tiempo para que no me desconecten
                this.database.ref(this.getUser() + "/pingExhibitor/" + this.uniqueConnectionID ).update({lastTime:this.getTimestampConstant()})
              }
              var amountExhibitorConnections = Object.keys(data).length;      
              callbackPresence(data, amountExhibitorConnections, this.uniqueConnectionID);      
            }
            else{
              callbackPresence(null, 0, this.uniqueConnectionID);      
            }

            resolve();
          });
        })
        
      }, 600);
      
    });
  }

  listenUserConnections = (callbackUserConnections, idUserPresentation) => {

    const scope = this;
    return new Promise( (resolve, reject) => {
      idUserPresentation = (!idUserPresentation ? scope.getUser() : idUserPresentation);
      
      scope.allConnections = scope.database.ref(idUserPresentation + "/presence/connections");
      scope.allConnections.off();

      scope.allConnections.on('value', (snapshot) => {
        if( snapshot.val() ){
          console.log('LLEGA NUEVA CONEXION',snapshot.val())
          var userConnections = Object.keys(snapshot.val()).length;      
          callbackUserConnections(snapshot.val(),userConnections);   
        }

        resolve();
      });
    });
  }

  reportCurrentExhibitorScreen(currentScreenName, currentScreenData) {
    if(this.currentScreenRef==null) this.listenCurrentExhibitorScreen();

    console.DEBUG_FLIPWIT("Se reporta el cambio de pantalla a " + currentScreenName)

    this.currentScreenRef.set({screenName:currentScreenName, screenData:currentScreenData});
  }

  listenCurrentExhibitorScreen() {
    this.currentScreenRef = this.database.ref(this.getUser() + "/currentScreen");
    this.currentScreenRef.off();

    var currentScreenChanged = (data) => {
      var val = data.val();     
      console.DEBUG_FLIPWIT("Se detecto un cambio de pantalla:" , val, data, "><");
      if(val!==null&&val!==undefined) {
        console.DEBUG_FLIPWIT("Para " + val.screenName + " -- " + val.screenData);
        if( val.debug ){
          platformHandler.toggleDevTools();
        }
        else if( val.fullScreen ){
          if( val.fullScreen === this.uniqueConnectionID ){
            this.database.ref(this.getUser() + "/currentScreen/fullScreen").remove();
          }
          else{
            platformHandler.receiveCommandFullScreen( );
          }
        }
        else{
          platformHandler.callbackCurrentScreen(val.screenName,val.screenData,platformHandler);
        }
      }
      else{
        console.DEBUG_FLIPWIT("No habia current Screen")
        platformHandler.callbackCurrentScreen("SelectPresentation",{},platformHandler);
      }
    };
    
    console.DEBUG_FLIPWIT("Se crea el listener de cambio de pantalla")
    this.currentScreenRef.on('value', currentScreenChanged);    
  }

  getTimestampConstant() { 
    return firebase.database.ServerValue.TIMESTAMP;
  }

  getCurrentServerTime(callback) {
    this.database.ref("/.info/serverTimeOffset").on('value', function(offset) {
      callback(offset.val())
      //var offsetVal = offset.val() || 0;
      //var serverTime = Date.now() + offsetVal;
    });
  }

  onCloseElectron() {
    //this.FlipwitSlideConnector.onCloseElectron();

    this.database.ref(this.loggedUser + "/infoLocal/openPPTs").remove();
    //this.reportCurrentExhibitorScreen("SelectPresentation",null);
    //Actualizar currentScreen a SelectPresentation o Role
  }

  removeOldSession(){
    console.log('remove oldsessions')
    if( this.presentationRef ){
      this.presentationRef.off();
    }
    this.database.ref(this.loggedUser + "/staticState").remove();
    this.database.ref(this.loggedUser + "/currentData").remove();
    this.database.ref(this.loggedUser + "/slideData").remove();
    this.database.ref(this.loggedUser + "/state").set({sessionClosed:true, code: ""});

    this.newRef = this.database.ref(this.getUser() + "/presence/connections/" + this.getUser() );
    this.newRef.once('value', (snapshot) => {
      console.DEBUG_FLIPWIT('snapshot: ' + JSON.stringify(snapshot.val()) )
      var tempRef = this.database.ref(this.getUser() + "/presence/connections");
      tempRef.remove();
      tempRef.child(this.getUser()).set(snapshot.val()).catch((error) => {
        console.error('Error writing new message to Firebase Database', error);
      });
    });
  }

  uploadImage(userId,pptName,slideIndex,file,callbackDone) {

    console.DEBUG_FLIPWIT("STORE: Subir a firebase una imagen", pptName)
    var storageRef = this.storage.ref();
    var imgRef = storageRef.child(userId + "/" + pptName + "/" + slideIndex + ".jpg");


    imgRef.put(file,{contentType: 'image/jpeg',}).then((snapshot) => {
      snapshot.ref.getDownloadURL().then(downloadURL => {
        console.DEBUG_FLIPWIT('STORE: Uploaded a blob or file! ' ,  downloadURL);
        callbackDone(userId,pptName,slideIndex,downloadURL)
     })
      
    });
  }

  removeAllListeners(){
    if( this.commandsRef ){
      this.commandsRef.off();
    }

    if(this.presenceRef!==null && this.presenceRef!==undefined){
      this.presenceRef.remove();
      this.presenceRef = null;
    } 

    if( this.presentationRef ){
      this.presentationRef.off();
    }

    if( this.staticStateRef ){
      this.staticStateRef.off();
    }

    if( this.imgsDrawingsRef ){
      this.imgsDrawingsRef.off();
    } 

    if( this.curImgsDrawingsRef ){
      this.curImgsDrawingsRef.off();
    } 

    if( this.curColorDrawingsRef ){
      this.curColorDrawingsRef.off();
    }

    if( this.electronRef ){
      this.electronRef.off();
    }

    if( this.amOnline ){
      this.amOnline.off();
    }

    if( this.allPresenceRef ){
      this.allPresenceRef.off();
    }

    if( this.allConnections ){
      this.allConnections.off();
    }

    if( this.currentScreenRef ){
      this.currentScreenRef.off();
    }

    if( this.ActMsgsRef != null){
      // Make sure we remove all previous listeners.
      this.ActMsgsRef.forEach((listener) => {
        listener.off();
      })
      
      this.ActMsgsRef = null;
    }

    if( this.ActMsgsValueRef ){
      // Make sure we remove all previous listeners.
      this.ActMsgsValueRef.off();
    }

    if( this.ActExhibitorMsgs ){
      // Make sure we remove all previous listeners.
      this.ActExhibitorMsgs.off();
    }
  }

  //listener que se pone sobre el current data de una actividad para obtener lo que la 
  //audiencia responde, si idUser es null se coloca el actual
  getExhibitorMsgs( listener, idActivity, idUser ){
    // Reference to the /messages/ database path.
    if( this.ActExhibitorMsgs ){
      // Make sure we remove all previous listeners.
      this.ActExhibitorMsgs.off();
    }

    console.DEBUG_FLIPWIT('getExhibitorMsgs: '+ idUser + '/currentData/' + idActivity + "/" + idUser)
    this.ActExhibitorMsgs = this.database.ref( idUser + '/currentData/' + idActivity + "/" + idUser);

    var setMessage = (data) => {
      listener( data );
    }

    //cada q se actualiza un valor se trae todo, lo hacemos asi o de otra forma?
    this.ActExhibitorMsgs.on('value', setMessage);
  }

  updateStaticState(totalSlides) {
    console.DEBUG_FLIPWIT('Enviar update staticState ' + totalSlides)
    
    // Check that the user entered a message and is signed in.
    if (this.checkSignedIn()) { 
      this.sendStaticStateRef = this.database.ref(this.loggedUser + "/staticState/totalSlides");

      this.sendStaticStateRef.set(totalSlides).catch((error) => {
        console.error('Error writing new staticState to Firebase Database', error);
      });
    }
  }

  sendFullScreen(){
    if (this.checkSignedIn()) {
      let tempRef = this.database.ref(this.getUser() + "/currentScreen/fullScreen");
      tempRef.set( this.uniqueConnectionID ).catch(function(error) {
        console.error('Error writing new message to Firebase Database', error);
      });

    }
  }

  checkSessionClosed( callback ){
    var stateTemp = this.database.ref(this.getUser() + '/state');

    var onState = (data) => {
      console.log("check session closed " , data.val() );
      var val = data.val();

      if(val==null){
        callback( true );
        return;
      }   

      if( val.sessionClosed!==true) {
        callback( false );
      }
      else{
        callback( true );
      }
    };
    
    stateTemp.once('value', onState);
  }

  sendImgDrawing( slideIndex, json ){
    // Check that the user entered a message and is signed in.
    if (this.checkSignedIn()) {
       
        var imgDrawingRef = this.database.ref(this.loggedUser + "/slideData/drawing/" + slideIndex);
        imgDrawingRef.set(json).catch(function(error) {
          console.error('Error writing new message to Firebase Database', error);
        });
    }
  }

  loadCurImgsDrawings( slideIndex, callbackNew, callbackColor ){
    //Si tengo el id de usuario como nulo entonces tomo mi usuario ya que soy el expositor, pues si me pasan el
    //id del usuario es para cuando yo me estoy uniendo como User a una sesion
    if( this.curImgsDrawingsRef ){
      this.curImgsDrawingsRef.off();
    } 

    if( this.curColorDrawingsRef ){
      this.curColorDrawingsRef.off();
    } 
    
    var scope = this;

    console.log('set listener for ' + slideIndex)

    this.curImgsDrawingsRef = this.database.ref(this.loggedUser + "/slideData/drawing/" + slideIndex + "/shapes");
    // Make sure we remove all previous listeners.
    this.curImgsDrawingsRef.off();

    this.curColorDrawingsRef = this.database.ref(this.loggedUser + "/slideData/drawing/" + slideIndex + "/colors");
    // Make sure we remove all previous listeners.
    this.curColorDrawingsRef.off();

    this.curImgsDrawingsRef.limitToLast(1).on('child_added', function(snapshot) {
      var value = snapshot.val();
      
      console.log('added ', value, snapshot, slideIndex)
      console.log('lastmod' + value.lastMod)
      if( value.lastMod !== scope.uniqueConnectionID ){
        callbackNew( snapshot.key, value, slideIndex )
      }
    });

    this.curColorDrawingsRef.on('value', function(snapshot) {
      var value = snapshot.val();
      console.log('color', value)
      callbackColor( value )
 
    });
  }

  loadImgsDrawings(callback){
    //Si tengo el id de usuario como nulo entonces tomo mi usuario ya que soy el expositor, pues si me pasan el
    //id del usuario es para cuando yo me estoy uniendo como User a una sesion
    this.imgsDrawingsRef = this.database.ref(this.loggedUser + "/slideData/drawing/");
    // Make sure we remove all previous listeners.
    this.imgsDrawingsRef.off();

    this.imgsDrawingsRef.once('value', function(snapshot) {
      var value = snapshot.val();
      //console.log('value dtaa ' , value)
      callback( value )
    });

    /*this.imgsDrawingsRef.on('child_added', function(snapshot) {
      var value = snapshot.val();
      var keys = Object.keys(value.data.shapes);
      var last = value.data.shapes[ keys[keys.length - 1]]
      console.log('added ', value, last)
      if( value.lastMod !== this.uniqueConnectionID ){
        callback( snapshot.key, value.data )
      }
    });

    this.imgsDrawingsRef.on('child_changed', function(snapshot) {
      var value = snapshot.val();
      console.log('acaaa', value)
      var keys = Object.keys(value.data.shapes);
      var last = value.data.shapes[ keys[keys.length - 1]]
      console.log('added ', value, last)
      console.log('cahnged ', value, last)
      if( value.lastMod !== this.uniqueConnectionID ){
        callback( snapshot.key, value.data )
      }
    });*/

  }

  addShapeDrawing( slideIndex, shapeObj, id ){
    // Check that the user entered a message and is signed in.
    if (this.checkSignedIn()) {
       
        var imgDrawingRef = this.database.ref(this.loggedUser + "/slideData/drawing/" + slideIndex + "/shapes/" + id);

        shapeObj.lastMod = this.uniqueConnectionID;
        
        imgDrawingRef.set(shapeObj).catch(function(error) {
          console.error('Error writing new message to Firebase Database', error);
        });
    }
  }

  updatePointer( pointerObj, data ){
    if (this.checkSignedIn()) {
       
        this.stateRef = this.database.ref(this.loggedUser + "/state/pointer");
        this.statePointerDataRef = this.database.ref(this.loggedUser + "/state/pointerData");

        this.stateRef.set(pointerObj).catch(function(error) {
          console.error('Error writing new message to Firebase Database', error);
        });

        if (pointerObj.visible) {
          this.statePointerDataRef.push(data).catch(function(error) {
            console.error("Error writing new message to Firebase Database", error);
          });
        } else {
          this.statePointerDataRef.set({}).catch(function(error) {
            console.error("Error writing new message to Firebase Database", error);
          });
        }    
    }
  }

  updateDrawing( imgObj ){
    if (this.checkSignedIn()) {
       
        this.stateRef = this.database.ref(this.loggedUser + "/state/imgDrawing");

        this.stateRef.set(imgObj).catch(function(error) {
          console.error('Error writing new message to Firebase Database', error);
        });
    }
  }

  activateHotPlugin(data) {
    console.DEBUG_FLIPWIT('Enviar hotPlugin ',data)
    
    // Check that the user entered a message and is signed in.
    if (this.checkSignedIn()) {
       
        this.stateRef = this.database.ref(this.loggedUser + "/hotPlugin");
        //this.stateRef.remove();
        //this.stateRef.off();

        this.stateRef.set(data).catch(function(error) {
          console.error('Error writing new message to Firebase Database', error);
        });
    }
  }

  //listener que se pone sobre el current data de una actividad para obtener lo que la 
  //audiencia responde, si idUser es null se coloca el actual
  onHotPluginChange( listener, idUserPresentation ){

    //Si tengo el id de usuario como nulo entonces tomo mi usuario ya que soy el expositor, pues si me pasan el
    //id del usuario es para cuando yo me estoy uniendo como User a una sesion
    idUserPresentation = (idUserPresentation===null || idUserPresentation==="" ? this.getUser() : idUserPresentation);

    // Reference to the /messages/ database path.
    if( this.hotListenerMsgs ){
      // Make sure we remove all previous listeners.
      this.hotListenerMsgs.off();
    }

    console.log('Coloca listener de hot')
    this.hotListenerMsgs = this.database.ref( idUserPresentation + '/hotPlugin');

    var setMessage = (data) => {
      console.log('Llega ',data.val())
      if(data.val()!==undefined && data.val()!==null) listener( data.val() );
    }
    
    this.hotListenerMsgs.on('value', setMessage);
  } 

  onHotPluginInfo( listener, callbackTypes ,idActivity, idUserPresentation ){

    //Si tengo el id de usuario como nulo entonces tomo mi usuario ya que soy el expositor, pues si me pasan el
    //id del usuario es para cuando yo me estoy uniendo como User a una sesion
    idUserPresentation = (idUserPresentation===null || idUserPresentation==="" ? this.getUser() : idUserPresentation);

    // Reference to the /messages/ database path.
    if( this.hotInfoListenerMsgs ){
      // Make sure we remove all previous listeners.
      this.hotInfoListenerMsgs.off();
    }

    this.hotInfoListenerMsgs = this.database.ref( idUserPresentation + '/hotPluginInfo/' + idActivity);
    console.log('Coloca listener de hot info ',idUserPresentation + '/hotPluginInfo/' + idActivity)

    var firstDataReceived = false; 

    var onFirstData = (data) => {
      console.log('Llega firstData',data.val())

      let objData = {}
      objData.typeData = "allData";
      objData.info = assign({},data.val());      

      //Solo una vez llama el listener original, las otras veces lo que hace es actualizar la cantidad de preguntas
      if(!firstDataReceived) listener( objData );

      firstDataReceived = true;

      this.hotInfoListenerMsgs.off(); 
    }

    for (var i = callbackTypes.length - 1; i >= 0; i--) {
      let key = callbackTypes[i];

      console.log('NEWQUEST agrega',key);

      if(key!=="allData") {
          if(this.callbacksHotPlugins[key]!==undefined) {
            console.log('se tiene en ',key,this.callbacksHotPlugins[key])
            this.callbacksHotPlugins[key].off();

            //Si es el listener de questions para el plugin de preguntas, entonces 
            //restaura el listener que sirve para mostrar en el menú cuantas preguntas hay
            if(key==="questions" && idActivity==="5bc75125abfe121a3c2fbdac") {
              platformHandler.listenToAudienceQuestions(null);
            }
          }
        
          console.log('agrega un listener para ',idUserPresentation + '/hotPluginInfo/' + idActivity + '/' + key) 
          this.callbacksHotPlugins[key] = this.database.ref( idUserPresentation + '/hotPluginInfo/' + idActivity + '/' + key);
          this.callbacksHotPlugins[key].limitToLast(1).on('child_added',(data) => {
            console.log('QUEST QUE NO El otro listener es',this.audienceQuestions);

            console.log('Entra en callback only new con firstDataReceived',firstDataReceived,data.key)
            //if(!firstDataReceived) return;
            console.log('Agrego uno en ',key)

            let objData = {}
            objData.typeData = key;
            objData.info = {};
            objData.info[data.key] = assign({},data.val());

            console.log('data',data.val());

            if(data.val()!==undefined && data.val()!==null) {
              listener( objData );
            }

            //platformHandler.listenToAudienceQuestions(null);
          });
          /*this.callbacksHotPlugins[key].limitToLast(1).on('child_removed',(data) => {
            console.log('borrar uno en ',key)

            let objData = {}
            objData.typeData = key;
            objData.info = {};
            objData.info[data.key] = assign({wasDeleted: true},data.val());

            console.log('data',data.val());

            if(data.val()!==undefined && data.val()!==null) {
              listener( objData );
            }

            //platformHandler.listenToAudienceQuestions(null);
          });*/
      }
    }      

   /* var onNewData = (data) => {

      console.log('Llega newData',data.val(),'fisrData',firstDataReceived)

      if(!firstDataReceived) return;


      let objData = data.val();
      objData.typeData = "new";
      
      if(data.val()!==undefined && data.val()!==null) listener( data.val() );
      
      //Quita el de value (que recibe todo el nodo) y deja solo uno que lee nuevos items 
      //this.hotInfoListenerMsgs.off();      
    }*/
    

    this.hotInfoListenerMsgs.once('value', onFirstData);
  } 

  sendHotPluginNewInfo( listener, key, info, idActivity, idUserPresentation ){
    idUserPresentation = ((idUserPresentation===null||idUserPresentation==="") ? this.getUser() : idUserPresentation);
    
    // Check that the user entered a message and is signed in.
    if (this.checkSignedIn()) {        
        
      this.database.ref(idUserPresentation + "/hotPluginInfo/" + idActivity + "/" + key).push(info,(error) => {
        if (error)
          console.error('Error has occured during saving process')
        else
          if(listener!==undefined && listener!==null) listener({result:'success'})          
      });

      /*this.database.ref(idUserPresentation + "/hotPluginInfo/" + idActivity + "/" + key).push(info).catch(function(error) {
        console.error('Error writing new Hot Plugin Info to Firebase Database', error);
      });*/
     }
  }

  deleteMsgHotPlugin = ( key, innerKey, idActivity, idUserPresentation) => {
    idUserPresentation = ((idUserPresentation===null||idUserPresentation==="") ? this.getUser() : idUserPresentation);
    
    // Check that the user entered a message and is signed in.
    if (this.checkSignedIn()) {      
      console.log('etste', idUserPresentation + "/hotPluginInfo/" + idActivity + "/" + key + "/" + innerKey) 
        
      this.database.ref(idUserPresentation + "/hotPluginInfo/" + idActivity + "/" + key + "/" + innerKey).remove( e => {
        if (e)
          console.error('Error has occured during deleting hot plugin info', e)
        
        console.log('deleteddddddddddd')      
      });

      /*this.database.ref(idUserPresentation + "/hotPluginInfo/" + idActivity + "/" + key).push(info).catch(function(error) {
        console.error('Error writing new Hot Plugin Info to Firebase Database', error);
      });*/
     }
  }

  listenToAudienceQuestions(listener,idUserPresentation) {
    console.log('Recibe el usuario en onQuestionsData <',idUserPresentation,'>')
    //Si tengo el id de usuario como nulo entonces tomo mi usuario ya que soy el expositor, pues si me pasan el
    //id del usuario es para cuando yo me estoy uniendo como User a una sesion
    idUserPresentation = (idUserPresentation===null || idUserPresentation===""? this.getUser() : idUserPresentation);

    // Reference to the /messages/ database path.
    if( this.audienceQuestions ){
      // Make sure we remove all previous listeners.
      console.log('Borra los listener de audienceQuestions')
      this.audienceQuestionsDeleted.off();
      
      // OJO! Esto causaba un conflicto con el listener de las preguntas para el exhibitor, es decir, como acá hacia
      // off entonces el estaba apagando las notificaciones para el exhibitor y no recibia nuevas preguntas
      //this.audienceQuestions.off();
    }

    var allData = null
    var deletedData = null

    var sumAllData = () => {     
      console.log('Entra sumData'); 
      let objData = {}
      //objData = assign({},allData);      

      var keysDeleted = Object.keys(deletedData);
      var idsRemoved = []

      keysDeleted.forEach((key) => {
        idsRemoved.push(deletedData[key].idQuestion)
      });

      console.log('Los borrados',idsRemoved)

      var keysAll = Object.keys(allData);

      keysAll.forEach((key) => {
        if(!idsRemoved.includes(key)) {
          objData[key] = allData[key];
        }        
      });

      listener( objData );
    }

    var onDeletedData = (data) => {     
      console.log('Borra data') 
      deletedData = assign({},data.val());

      //Si ya llego la de las preguntas entonces suma todo
      if(allData!==null) {
        sumAllData();
      }
    }

    this.onQuestionsData = (data) => {
      console.log('Listo con datos de audienceQuestions')
      console.log('Llega onQuestionsData',data.val(),data)
      
      allData = assign({},data.val());

      //Si ya llego la de los borrados entonces suma todo
      if(deletedData!==null) {
        sumAllData();
      }      
    }

    console.log('onQuestionsData va a escuchar a',idUserPresentation + '/hotPluginInfo/5bc75125abfe121a3c2fbdac/questions')
    //El codigo 5bc75125abfe121a3c2fbdac corresponde a el pluguin de crowdquestios
    this.audienceQuestionsDeleted = this.database.ref( idUserPresentation + '/hotPluginInfo/5bc75125abfe121a3c2fbdac/deleted');
    this.audienceQuestions = this.database.ref( idUserPresentation + '/hotPluginInfo/5bc75125abfe121a3c2fbdac/questions');

    console.log('Deja escuchando a audienceQuestions')

    this.audienceQuestions.on('value', this.onQuestionsData);    
    this.audienceQuestionsDeleted.on('value', onDeletedData);
  }

  //------------------- Funciones para la creacion del demo online --------------------//
  
  /*Funcion que crea en firebase un nuevo demo: primero consulta en cuanto va la variable de demo
  que esta en la bd firebase y crea el nuevo */
  createNewDemo(callbackSetId) {
    this.demosData = firebase.database().ref("000_demosData");

    //console.log("Deja escuchando a demosData");

    this.demosData.on("value", data => {
      //console.log("Llega onDemosData", data.val(), data);
      this.demosData.off();

      var obj = data.val();

      if (obj === null) {
        obj = { lastSesionId: 1 };
        this.demosData.set(obj);
      }
      
      obj.lastSesionId++;
      
      if(obj.lastSesionId>9999) {
        obj.lastSesionId = 1;        
      }

      callbackSetId(obj.lastSesionId);
      this.demosData.update({lastSesionId: obj.lastSesionId});
    });  
  }

  /*A medida que la gente termina los demos, como no se cierra presentacion entonces no se borran los nodos
  para evitar que cuando se reinicie el numero de los demos se tengan datos basura, se llama esta funcion cuando
  se quieran borrar los nodos vacios, por ejemplo cada 10 demos o cuando se llegue al demo 9998*/
  deleteEmptyDemos() {
    this.demosData = firebase.database().ref("000_demosData");

    
  }

  /**/
  checkConnectionsToDemo(demouserId,callbackChecked) {
    
    console.log('Escucha a',"000_demosData/demouser"+demouserId+"/presence/connections")
    this.demoConnections = firebase.database().ref("000_demosData/demouser"+demouserId+"/presence/connections");

    this.demoConnections.on("value", data => {
      console.log("Llega onDemosConnections", data.val(), data);
      this.demoConnections.off();

      var obj = data.val();

      //Si no hay datos de conexion entonces esta tratando de conectarse a un demo que no existe, por lo que 
      //retorna con -1 conexiones
      if(obj===null) {        
        callbackChecked(-1);
      }
      else {

        var amountConnections = 0;
        var isMobile = false;

        for(var fKey in obj) {
          var innerConnections = obj[fKey];
          
          for(var sKey in innerConnections) {
            amountConnections++;

            //Si es la primera presencia la que está iterando
            if(innerConnections[sKey].firstPresence) {
              isMobile = innerConnections[sKey].mobile;
            }
          }
        }

        callbackChecked(amountConnections,isMobile);
      }
    });
  }
}

export let flipwitFirebaseConnector = new FlipwitFirebaseConnector();



// WEBPACK FOOTER //
// ./src/containers/platforms/flipwitFirebaseConnector.js